<template>

  <div>

    <div v-if="contract.product">




      <h5 class="info-text" style="margin:auto;text-align:center;margin-top:50px;margin-bottom:50px;">Here you can review and sign your contract</h5>


      <div class="row justify-content-center">
        <ul>
          <li>{{contract.product}} - <a href="#" @click.prevent="downloadPdf(contract.pdf)">{{contract.pdf}}</a></li>
        </ul>
      </div>

      <div class="row justify-content-center">
        <!--
        <div class="col-md-12 col-lg-12 col-12" style="margin:auto">

          <ul slot="raw-content" class="list-group list-group-flush" style="margin:auto;text-align: center;max-width: 200px;margin-bottom: 25px;">
            <li class="list-group-item" v-for="item, key in contracts" v-if="item.status === true"><a href="#"> <i class="nc-icon nc-zoom-split"></i> {{key}}</a></li>
          </ul>
        </div>
  -->

        <div class="col-md-12 mr-auto ml-auto" style="margin:auto; text-align:center;">
          <vue-esign ref="esign" :width="800" style="border: solid 1px; margin:auto" :height="300" :isCrop="signPad.isCrop" :lineWidth="signPad.lineWidth" :lineColor="signPad.lineColor" :bgColor.sync="signPad.bgColor" />
          <button class="btn btn-info" @click="handleReset">Reset</button>
          <button class="btn btn-success" @click="handleGenerate">Sign</button>

          <br><!--<img v-if="signPad.resultImg" style="width:200px;" :src="signPad.resultImg"> <br><cite v-if="signPad.resultImg">Lu et approuvé</cite>-->
        </div>
      </div>

      </div>
      <div v-if="!contract.product">
        <h5 class="info-text" style="margin:auto;text-align:center;margin-top:50px;margin-bottom:50px;">This link is not valid anymore</h5>
      </div>
  </div>
</template>
<script>
import {Select, Option} from 'element-ui'
import vueEsign from 'vue-esign'
export default {
  props: ['contracts'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      token: this.$route.query.token.toString(),
      timest: this.$route.query.timest.toString(),
      contract: {},
      links: [],
      model: {},
      value: [],
      signPad: {
        lineWidth: 1,
        lineColor: '#000000',
        bgColor: '',
        resultImg: '',
        isCrop: false
      }
    }
  },
  mounted() {
    this.getInfos()
  },
  methods: {
    getInfos() {
      this.$http({
        method: 'get',
        url: this.$GuestUrl + '/contract/contract_to_sign', // /contract/contract_to_sign
        //responseType: 'blob',
        params: {token: this.token, timest: this.timest}
      }).then(response => (
          this.contract = response.data
      )).catch(err => {
        alert(err)
      })
    },
    downloadPdf (item) {
      this.$http({
        method: 'get',
        url: this.$GuestUrl + '/contract/pdf',
        //headers: {'Authorization': 'Bearer ' + localStorage.token},
        responseType: 'blob',
        params: {token: this.token, timest: this.timest}
      }).then(response => (
          this.link = document.createElement('a'),
              this.url = window.URL.createObjectURL(new Blob([response.data])),
              this.link.href = this.url, this.link.setAttribute('download', item), document.body.appendChild(this.link), this.link.click()
      )).catch(err => {
        alert(err)
      })
    },
    handleReset () {
      this.$refs.esign.reset(),
          this.signPad.resultImg = ''
    },
    handleGenerate () {
      this.$refs.esign.generate().then(res => {
        this.contract.sign = res,
        this.contract.sign_date = new Date(),
        this.$http({
          method: 'post',
          url: this.$GuestUrl + '/contract/contract_to_sign', // /contract/contract_to_sign
          //responseType: 'blob',
          params: {token: this.token, timest: this.timest},
          data: this.contract
        }).then(response => (
            alert('Contract signed'),
            this.contract = {}
            //this.contract = response.data
        )).catch(err => {
          alert(err)
        })
      }).catch(err => {
        alert(err) //
      })

    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.$refs.esign.generate().then(rs => {
        this.signPad.resultImg = rs
      }).catch(err => {
        alert(err) //
      });


    }
  }

}
</script>
<style>
</style>
